<template>
  <div>
    <damage v-on:delete-damage="deleteDamage" v-for="damage in damages" :damage.sync="damage" :key="damage.id"></damage>
  </div>
</template>

<script>
	
	
import sweetalert from 'sweetalert';
import Damage from '@/components/Damages/Damage';
export default {
  props: ['damages'],
  components: {
    Damage,
  },
  methods: {
    deleteDamage(damage) {	    
		sweetalert({
		  title: "Weg mit dem Dreck?",
		  text: "Kann nicht wieder hergestellt werden!",
		  icon: "warning",
		  buttons: {
			  cancel: {
			    text: "Nein",
			    value: null,
			    visible: true,
			    className: "",
			    closeModal: true,
			  },
			  confirm: {
			    text: "Ja, löschen!",
			    value: true,
			    visible: true,
			    className: "",
			    closeModal: true
			  }
			},
		  dangerMode: true,
		})
		.then((willDelete) => {
		  if (willDelete) {
		      const damageIndex = this.damages.indexOf(damage);
		      this.$socket.emit('syncDamages', { action: "delete",  data: { id: damage.id } } );
		      this.damages.splice(damageIndex, 1);
		  }
		});	    
    },
  },
};
</script>

<style scoped>
p.tasks {
  text-align: center;
}
</style>